module.exports = __webpack_public_path__ + "img/photo-13.df805771.webp";